<!-- Formulario de retiro -->
<div class="withdraw-container" *ngIf="!showConfirmation && totalAccounts >= 1">
  <form [formGroup]="wdForm">
    <div class="header">
      <p>Retiro de fondos</p>
      <img (click)="close()" class="my-auto" height="13" src="assets/icon/x.svg" alt="close">
    </div>

    <div class="body">
      <p class="mb-1">Retira tus fondos a una cuenta bancaria propia.</p>
      <p class="info">¡Importante! Solo puedes realizar dos retiros mensuales (uno cada 24hrs).</p>

      <!-- Saldo disponible -->
      <div class="balance-card">
        <div class="balance-label">Saldo disponible</div>
        <div class="balance-amount">{{ balance | currency: 'MXN' }}</div>
      </div>

      <!-- Cuenta destino -->
      <div class="form-section">
        <label class="mnf-control-label">Cuenta destino</label>
        <mat-form-field appearance="outline" class="mnf-select mb-2">
          <mat-select disableRipple formControlName="bankAccount">
            <mat-option [value]="ba" *ngFor="let ba of bankAccounts" [title]="ba.alias">
              {{ ba.alias }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <p class="selected-account-info" *ngIf="selectedAccountInfo">
          {{ selectedAccountInfo }}
        </p>
      </div>

      <!-- Monto a retirar -->
      <div class="form-section">
        <label class="mnf-control mb-2">
          <p class="mnf-control-label">Monto a retirar</p>
          <div class="d-flex align-items-center">
            <input
              class="mnf-input-form"
              [ngClass]="{ error: (control.touched && control.invalid) || showInsufficientFunds }"
              formControlName="amount"
              currencyMask
              maxlength="18"
              autocomplete="off"
              placeholder="$0.00"
            >
          </div>
          <button
            type="button"
            class="btn-custom-link ms-2 mt-2 mb-4"
            (click)="addAll()">
            Agregar todo
          </button>
        </label>
      </div>

      <!-- Información de saldo restante -->
      <div class="d-flex mb-5 balance-info" *ngIf="!showInsufficientFunds">
        <img class="me-2 my-auto" height="12" src="assets/icon/info.svg" alt="">
        <p class="wd-info">Después del retiro, tu saldo será de
          <span class="cl-primary-7">{{ remainingBalance | currency: 'MXN' }}</span>
        </p>
      </div>

      <!-- Mensaje de saldo insuficiente -->
      <div class="error-message" *ngIf="showInsufficientFunds">
        <img class="me-2 my-auto" height="12" src="assets/icon/close.svg" alt="">
        <p>El monto a retirar no puede ser mayor al saldo disponible</p>
      </div>

      <!-- Botón de continuar -->
      <div class="text-center">
        <button mat-button type="button"
                [disabled]="!wdForm.valid || showInsufficientFunds"
                (click)="showConfirmationScreen()">
          Continuar
        </button>
      </div>
    </div>
  </form>
</div>

<!-- Pantalla de confirmación -->
<div class="withdraw-container confirmation-view" *ngIf="showConfirmation && totalAccounts >= 1">
  <div class="header">
    <p>Confirmar retiro</p>
    <img (click)="close()" class="my-auto" height="13" src="assets/icon/x.svg" alt="close">
  </div>

  <div class="body">
    <h3 class="confirmation-title">Revisa los detalles de tu retiro</h3>

    <!-- Tabla de resumen -->
    <div class="summary-table">
      <div class="summary-row" *ngFor="let item of withdrawSummary"
           [ngClass]="{ 'highlight': item.highlight, 'with-icon': item.icon }">
        <div class="summary-label">
          <img *ngIf="item.icon" [src]="item.icon" alt="" class="summary-icon">
          {{ item.label }}
        </div>
        <div class="summary-value" [ngClass]="{ 'cl-primary-7': item.highlight }">
          {{ item.value }}
        </div>
      </div>
    </div>

    <!-- Botones de acción -->
    <div class="action-buttons">
      <button mat-button type="button" class="btn-secondary" (click)="backToForm()">
        Regresar
      </button>
      <button mat-button type="button"
              class="btn-primary"
              [disabled]="isProcessing"
              (click)="confirmWithdraw()">
        <span *ngIf="!isProcessing">Confirmar retiro</span>
        <span *ngIf="isProcessing">Procesando...</span>
      </button>
    </div>
  </div>
</div>

<!-- No hay cuentas bancarias -->
<ng-container *ngIf="totalAccounts === 0">
  <div class="header">
    <p>Retiro de fondos</p>
    <img (click)="close()" class="my-auto" height="13" src="assets/icon/x.svg" alt="close">
  </div>
  <div class="body">
    <h3 class="text-center fs-24 fw-sbold">¡Asocia una cuenta de Banco!</h3>
    <p class="mt-4 fs-14">
      Para realizar un retiro debes abonar saldo a tu <strong>CLABE STP</strong> desde una cuenta de banco
      <strong>que esté a tu nombre y automáticamente aparecerá en la lista de tus cuentas asociadas en Monific.</strong>
    </p>
    <p class="mt-3 fs-14">
      Si tú por ejemplo invertiste desde una cuenta bancaria, pero deseas retirarlo a otra cuenta bancaria,
      debes de abonar saldo desde la cuenta en la que deseas retirar, recordando que las mismas deben estar a tu nombre.
    </p>
    <p class="mt-3 fs-13"><strong>¡Recuerda: máximo 2 retiros mensuales y un retiro diario!</strong></p>
    <p class="mt-3 fs-14">
      En caso de que tu cuenta no se asocie, incluso después de abonar, probablemente un dato de tu perfil
      está incorrecto y debemos revisarlo para corregirlo y que te permita continuar con el retiro.
    </p>
    <div class="text-center mt-5">
      <button mat-button type="button" (click)="close()">Entendido</button>
    </div>
  </div>
</ng-container>
